import { Component, Input, OnInit } from '@angular/core';
import { AlertController, ModalController, Platform } from '@ionic/angular';
import { DeleteRoomModalComponent } from 'src/app/pages/package-details/package-booking/delete-room-modal/delete-room-modal.component';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';

@Component({
  selector: 'app-options-modal',
  templateUrl: './options-modal.component.html',
  styleUrls: ['./options-modal.component.scss'],
})
export class OptionsModalComponent implements OnInit {
  driver:any;
  @Input() index:any;
  @Input() driverAssginged:any;
  @Input() caddyNo:any;
  @Input() caddyIndex:any;
  @Input() data:any;
  @Input() newSetBuggySeating:(index:any,data:any) => void;
  @Input() newSetCaddyPairing:(index:any,data:any) => void;
  @Input() onNewSelectCaddy:(index:any,data:any) => void;
  @Input() goUpdatePlayerContact:(data:any) => void;
  @Input() getCaddyPreferred:(index:any,data:string) => any;
  @Input() newClearPlayerDetails:(index:any) => any;
  @Input() hasBuggyPlayerType: boolean;
  // @Input() hasBuggyPlayerType:(index:any) => any;
  @Input() onSelectBuggyType:(index:any) => any;
  @Input() getBuggySlotDisplay:(index:any) => any;
  @Input() getBuggyTypeDisplay:(index:any) => any;
  constructor(
    private modalCtl: ModalController,
    private mg2uUtil: mygolfUtils,
    private alertCtrl: AlertController,
    private platform: Platform,
  ) { }

  ngOnInit() {
    this.driver =this.driverAssginged
  }

  async emitEvent(index, event:any) {
    this.newSetBuggySeating(index,event)
  }

  async caddyEvent(index, event:any) {
    this.newSetCaddyPairing(index,event)
  }

  async favCaddy(index, caddyNo:any) {
    this.onNewSelectCaddy(index,caddyNo)
  }

  async editButton() {
    console.log('editButton: ');
    this.goUpdatePlayerContact(this.data)
  }

  cancle(){
    this.modalCtl.dismiss();
  }

  confirm(){
    let obj = {
      driverValue:this.driver
    }
    this.modalCtl.dismiss(obj)
  }

  buggyTypeEmit(i:any,e:any){
    this.onSelectBuggyType(i)
  }

  async clear(){
    let printModal = await this.modalCtl.create({
      component: DeleteRoomModalComponent,
      componentProps: {
        mode: 'CLearPlayerDetail',
      },
      showBackdrop: true,
      mode: 'ios',
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
    });
    await printModal.present().then(() => {
      const height = this.platform.height() - 180;
      document.getElementsByClassName('inner-content')[0][
        'style'
      ].maxHeight = `${height}px`;
    });
    printModal.onWillDismiss().then(async (data) => {
      if (data?.data) {
        switch (data?.data) {
          case 'Clear':
          await this.clearDetail()
        }
      }
    });
  }

  async clearDetail(){
    await this.newClearPlayerDetails(this.index);
    await this.modalCtl.dismiss()
  }


  async onSelectDriver(){
    let printModal = await this.modalCtl.create({
      component: DeleteRoomModalComponent,
      componentProps: {
        mode: 'selectDriver',
      },
      showBackdrop: true,
      mode: 'ios',
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
    });
    await printModal.present().then(() => {
      const height = this.platform.height() - 180;
      document.getElementsByClassName('inner-content')[0][
        'style'
      ].maxHeight = `${height}px`;
    });
    printModal.onWillDismiss().then(async (data) => {
      if (data?.data) {
        switch (data?.data) {
          case 'Yes':
          this.driver="Yes";
          break;
          case 'No':
          this.driver="No";
          break;
        }
      }
    });
  }

}
